<script setup lang="ts">
import { ref, computed } from 'vue'
import { Button } from '@/lib/ui/button'
import { Trash2 } from 'lucide-vue-next'
import { ConfirmationDialog } from '@/components/ConfirmationDialog'
import { useChatSession } from '@/composables/useChatSession'

const chatSession = useChatSession()

const showDialog = ref(false)

const hasHistory = computed(
  () => chatSession.store.hasMessages || chatSession.store.hasHistoricalMessages
)

function handleConfirm() {
  chatSession.store.clearHistory()
}
</script>

<template>
  <Button
    v-if="hasHistory"
    variant="ghost"
    size="icon"
    aria-label="Clear chat history"
    @click="showDialog = true"
  >
    <Trash2 :size="20" />
  </Button>

  <ConfirmationDialog
    v-model:open="showDialog"
    title="Clear chat history"
    description="This will permanently delete all chat history. This action cannot be undone."
    confirm-label="Clear"
    :destructive="true"
    @confirm="handleConfirm"
  />
</template>
